import { createContext, useContext, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import ruMessages from '../i18n/messages/ru.json';
import uaMessages from '../i18n/messages/ua.json';
import { useLocalStorage } from '../hooks';
import { LANGUAGE_STORAGE_KEY } from '../constants';

interface Props {
  children: React.ReactNode;
}

interface LanguageContextType {
  locale: string;
  setLocale: (locale: string) => void;
}

export const LanguageContext = createContext<LanguageContextType>({
  locale: 'uk',
  setLocale: () => {},
});

export const useLanguage = () => useContext(LanguageContext);

const messages = {
  ru: ruMessages,
  uk: uaMessages,
};

export function IntlProvider({ children }: Props) {
  const [savedLocale] = useLocalStorage(LANGUAGE_STORAGE_KEY, 'uk');
  const [locale, setLocale] = useState(savedLocale || 'uk');

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      <ReactIntlProvider
        messages={messages[locale as keyof typeof messages]}
        locale={locale}
        defaultLocale='uk'
      >
        {children}
      </ReactIntlProvider>
    </LanguageContext.Provider>
  );
}
